export default __webpack_public_path__ + "static/media/crossroads4.cca263f7.webp";